module.exports = __webpack_public_path__ + "static/media/007-folder.1ab1df34.svg";